import React, { useState, useMemo } from 'react';

function Repertoire() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  // Song categories for better organization
  const categories = {
    classical: "Classical Pieces",
    movie: "Movie & TV Soundtracks",
    pop: "Pop & Contemporary",
    musical: "Musical Theater",
    jazz: "Jazz & Standards"
  };

  const classicalPieces = [
    "Claire de Lune - Debussy",
    "Passacaglia - Handel",
    "Nocturno Op 9 No 2 - Chopin",
    "Fur Elise - Beethoven",
    "Marcha Ala Turca - Mozart",
    "Canon in D - Pachbell",
    "The Swan - Eric Satie",
    "Lacrimosa - Mozart",
    "Ave María - Shubert",
    "Hungarian Dance no 5 in Gm - J Brahms",
    "Waltz no 2 - Shostackovich",
    "Gnosienne no 1 - Eric Satie",
    "Czardas - Monti",
    "Habanera from Carmen - Bizet",
    "Waltz Op 69 No 2 in Bm - Chopin",
    "Polonesa 4 - Chopin",
    "Nocturno no 20 c #m - Chopin",
    "Fantasía Impromptu - Chopin",
    "Nocturno Op 9 No 1 - Chopin",
    "Waltz in A m - Chopin",
    "Waltz Op 69 No 2 in B m - Chopin",
    "Prelude No 15 Op 28 - Chopin",
    "Prelude No 4 Op 28 E m - Chopin",
    "Balada No 1 Gm - Chopin",
    "Arabesque No 1 in E M - Claude Debussy",
    "Waltz of the Flowers - Tchaikovsky",
    "Swan Lake - Tchaikovsky",
    "Waltz of the Sugar Plum Fairy - Tchaikovsky",
    "Moonlight Sonata (1 mov) - Beethoven",
    "Summer - Vivaldi"
  ];

  const contemporaryPieces = [
    "Idea 10 - Gibran Alcocer",
    "Idea 22 - Gibran Alcocer",
    "Marriage de Amour - Paul de Senneville",
    "Carol of the Bells - Leontovich",
    "Experience - Einaudi",
    "Nuviole Bianci - Einaudi",
    "Una Mattina - Einaudi",
    "Divenire - Einaudi",
    "Temple White - Einaudi",
    "Comptine d'un autre etè - Yann Tiersen",
    "Love Story - Francis Lai",
    "Love Story - Indila",
    "River Flows in You - Yiruma",
    "Kiss the Rain - Yiruma",
    "Reminiscent - Yiruma",
    "Spring Time - Yiruma",
    "Another Love - Tom Odell",
    "Now We are Free (Gladiator) - Hans Zimmer",
    "Interestellar - Hans Zimmer",
    "Pirates of the Caribbean - Hans Zimmer",
    "Tennessee - Hans Zimmer (Pearl Harbor)",
    "Señorita - Camila Cabello",
    "Yellow - Coldplay",
    "Viva la vida - Coldplay",
    "The Scientist - Coldplay",
    "Clocks - Coldplay",
    "Por una Cabeza - Carlos Gardel",
    "Lovely - Billie Eilish",
    "What I was made for - Billie Eilish",
    "No time to Die - Billie Eilish",
    "Burda of a feather - Billie Eilish",
    "Chihiro - Billie Eilish",
    "Feeling Good - Michael Bublé",
    "Swan - Michael Bublé",
    "Fly me to the moon - Frank Sinatra",
    "New York - Frank Sinatra",
    "Autumn Leaves - Bill Evans",
    "Cinema Paradiso - Morricone",
    "Theme From Schindler's List - J Williams",
    "Skyfull - Adele",
    "Set Fire to the Rain - Adele",
    "Rolling in the Deep - Adele",
    "Someone like You - Adele",
    "The Godfather (movie)",
    "Ballade pour Adeline - Richard Clayderman",
    "Demons - Imagine Dragons",
    "Believer - Imagine Dragons",
    "Space Song - Beach House",
    "All of Me - J Legend",
    "My heart will go on - Celine Dion",
    "Power of love - Celine Dion",
    "Perfect - Ed Sheeran",
    "Shivers - Ed Sheeran",
    "Right Here Waiting for you - Richard Max",
    "Always Remember Us This Way - Lady Gaga",
    "Shallow - Lady Gaga",
    "Die With smile - Lady Gaga & Bruno Mars",
    "La vie en rose - Edith Piaf",
    "La faute - Edith Piaf",
    "Hallelujah - Leonard Cohen",
    "Dance me to the end of love - Leonard Cohen",
    "Jardin Secret - Paul de Senneville",
    "Until I found You - Stephen Sánchez",
    "In the stars - Benson Boone",
    "Beautiful Things - Benson Boone",
    "Talking to the moon - Bruno Mars",
    "When I was your man - Bruno Mars",
    "Marry You - Bruno Mars",
    "Stand by me - Ben E King",
    "Back to black - Amy Winehouse",
    "Unchained melody - R brothers",
    "Bella Ciao (Casa de papel)",
    "Piano Man - Billy Joel",
    "Honesty - Billy Joel",
    "Golden Hour - JVKE",
    "I will survive - Gloria Gaynor",
    "Je te laisserai des mots - Patrick Watson",
    "Despacito - Luis Fonsi & Daddy Yankee",
    "Fallen Down - Toby Fox",
    "Hijo de la luna - Mecano",
    "A thousand Years - Christina Perri",
    "Game of Thrones - Ramin Djawadi",
    "Dawn (Pride and Prejudice) - Dario Martinelli",
    "The Entertainer - Scott Joplin",
    "Howl's Moving Castle (movie)",
    "Can't Help Falling in Love - Elvis Presley",
    "Bohemian Rhapsody - Queen",
    "As it was - Harry Styles",
    "Expresso - Sabrina Carpenter",
    "Turning Page",
    "Tubular Bells",
    "Careless Whisper - George Michael",
    "Vivo per lei - Andrea Bocelli",
    "Romanza - Andrea Bocelli",
    "Time to say goodbye - Andrea Bocelli",
    "Princess Mononoke",
    "Song From a Secret Garden",
    "Coimear Tendresse",
    "La La Land (Mia and Sebastian theme)",
    "If I ain't got you - Alicia Keys",
    "The Night we meet",
    "Liz on the top of the world",
    "Paris, Texas - Lana del Rey",
    "Dandelions - Ruth B",
    "Oceans",
    "I will always love you - Whitney Houston",
    "Calm Down - Rema",
    "Tattoo - Loreen",
    "Solas - Jaime Duffy",
    "A Lara's theme",
    "Lover - Taylor Swift",
    "Africa - Toto",
    "The Final Countdown - Europe",
    "A comme amour",
    "Memory - Andrew Lloyd",
    "Girl from Ipanema",
    "I see the Light (Tangled)",
    "Let it Go (Frozen)",
    "How Far I'll Go (Moana)",
    "Beauty and The Beast (movie)",
    "Flowers - Miley Cyrus",
    "I'm Good - Blue",
    "Children - Robert Miles",
    "I dreamed a Dream - Les Misérables",
    "Love is Blue - André Popp",
    "Never Enough (The Greatest Showman)",
    "Ily (i love you baby) - Surf Mesa",
    "The Music of the Night",
    "City of Stars (La La Land)",
    "Runaway",
    "The Night - Avicii",
    "Waiting for love - Avicii",
    "A Million Dreams (The Greatest Showman)",
    "Voilà - Barbara Pravi",
    "La manège",
    "Bésame Mucho - Consuelo Velázquez",
    "Imagine - John Lennon",
    "Let it be - The Beatles",
    "Total Eclipse of the Heart - Bonnie Tyler",
    "I Just Called To Say I Love You - Stevie Wonder",
    "Love Grows - Edison Lighthouse",
    "Only You - The Platters",
    "Libertango - Astor Piazzolla",
    "Over The Rainbow",
    "Drivers License - Olivia Rodrigo",
    "Vampire - Olivia Rodrigo",
    "Blinding Lights - The Weeknd",
    "Chiquitita - ABBA",
    "Money Money Money - ABBA",
    "Gimme Gimme Gimme - ABBA",
    "Lay all your love on me - ABBA",
    "Everything I do - Bryan Adams",
    "I'm not the Only One - Sam Smith",
    "Killing me Softly - The Fugees",
    "Tell me Why - Backstreet Boys",
    "Dance Monkey - Tones and I",
    "Aladdin (movie)",
    "Hit The Road Jack",
    "Requiem for a Dream",
    "Hotline Bling",
    "Overture Snowman - Sia",
    "Beastars - Wild Side",
    "Lambada - Kaoma",
    "Secret Piano",
    "Once Upon a December (Anastasia)",
    "Sweetly",
    "I like to move it",
    "Wake me up",
    "Old doll",
    "Danza Kuduro",
    "Dernière Danse - Indila",
    "Asterism - The Titan",
    "Misty",
    "In a Sentimental Mood - Duke Ellington",
    "I like the way you kiss me",
    "Night Dancer",
    "Kingdom Dance",
    "Love Nwantiti - CKay",
    "Sparkle",
    "Faded - Alan Walker",
    "Married Life",
    "No Woman No Cry",
    "Forbidden Love",
    "Ghlibi Style Nostalgic Waltz"
  ];

  // Categorize contemporary pieces
  const categorizedSongs = {
    movie: contemporaryPieces.filter(song => 
      song.includes("movie") || 
      song.includes("Greatest Showman") || 
      song.includes("La La Land") || 
      song.includes("Frozen") || 
      song.includes("Tangled") ||
      song.includes("Moana") ||
      song.includes("Game of Thrones") ||
      song.includes("Pirates") ||
      song.includes("Howl's")
    ),
    musical: contemporaryPieces.filter(song =>
      song.includes("Les Misérables") ||
      song.includes("Phantom") ||
      song.includes("Musical") ||
      song.includes("Theater")
    ),
    jazz: contemporaryPieces.filter(song =>
      song.includes("Duke Ellington") ||
      song.includes("Frank Sinatra") ||
      song.includes("Jazz") ||
      song.includes("Blues") ||
      song.includes("Autumn Leaves")
    ),
    pop: contemporaryPieces.filter(song => 
      !song.includes("movie") && 
      !song.includes("Greatest Showman") && 
      !song.includes("Musical") &&
      !song.includes("Duke Ellington") &&
      !song.includes("Frank Sinatra")
    )
  };

  // Filter songs based on search term
  const filteredSongs = useMemo(() => {
    const term = searchTerm.toLowerCase();
    if (activeCategory === 'all') {
      return [...classicalPieces, ...contemporaryPieces].filter(song =>
        song.toLowerCase().includes(term)
      );
    } else if (activeCategory === 'classical') {
      return classicalPieces.filter(song =>
        song.toLowerCase().includes(term)
      );
    } else {
      return categorizedSongs[activeCategory]?.filter(song =>
        song.toLowerCase().includes(term)
      ) || [];
    }
  }, [searchTerm, activeCategory]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-ivory to-white">
      {/* Hero Section */}
      <div 
        className="h-[300px] bg-cover bg-center relative"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?auto=format&fit=crop&w=2000&q=80")'
        }}
      >
        <div className="absolute inset-0 bg-piano-black/50" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-5xl font-serif text-ivory mb-4">Repertoire</h1>
            <p className="text-xl text-ivory/90">A collection of timeless melodies</p>
          </div>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="mb-8">
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
            <input
              type="text"
              placeholder="Search songs..."
              className="w-full sm:w-96 px-4 py-2 rounded-lg border border-piano-black/20 focus:outline-none focus:ring-2 focus:ring-piano-black/20"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="flex gap-2 flex-wrap justify-center">
              <button
                onClick={() => setActiveCategory('all')}
                className={`px-4 py-2 rounded-full text-sm ${
                  activeCategory === 'all'
                    ? 'bg-piano-black text-ivory'
                    : 'bg-ivory text-piano-black border border-piano-black/20 hover:bg-piano-black/5'
                }`}
              >
                All
              </button>
              {Object.entries(categories).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => setActiveCategory(key)}
                  className={`px-4 py-2 rounded-full text-sm ${
                    activeCategory === key
                      ? 'bg-piano-black text-ivory'
                      : 'bg-ivory text-piano-black border border-piano-black/20 hover:bg-piano-black/5'
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Songs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredSongs.map((piece, index) => (
            <div
              key={index}
              className="p-4 bg-ivory rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-piano-black/10 hover:border-piano-black/30"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-piano-black/5">
                  <svg
                    className="w-4 h-4 text-piano-black/70"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
                    />
                  </svg>
                </div>
                <span className="text-piano-black/90 font-medium">{piece}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredSongs.length === 0 && (
          <div className="text-center py-12">
            <p className="text-piano-black/70 text-lg">
              No songs found matching your search criteria
            </p>
          </div>
        )}
      </div>

      {/* Decorative Element */}
      <div className="fixed bottom-0 left-0 right-0 h-4 bg-gradient-to-r from-ivory via-piano-black to-ivory opacity-20" />
    </div>
  );
}

export default Repertoire;
